"use client"

import { DoorOpen } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `DoorOpenIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const DoorOpenIcon = component(Icon)({ as: DoorOpen })
